import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Sporcu yorumları" className="bg-warm" data-id="element-324" data-mp="3ksgyi97eejdg">
      <div className="mx-auto max-w-6xl px-5 py-14 lg:py-20" style={{
      paddingTop: "18px"
    }} data-id="element-325" data-mp="3fym9cq90xc6z">
        <h2 className="text-center font-display text-3xl font-extrabold uppercase leading-none text-navy sm:text-5xl" data-id="element-326" data-mp="3azjd9vb0ugb5">
          Gerçek sporcuların deneyimleri
        </h2>
        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6" data-id="element-327" data-mp="3205ziqfv75km">
          {testimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i * 0.05} data-id="element-328" data-mp="2x09wouiwlk6n" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}